import { ChangeDetectorRef, Component, Inject, OnInit, SimpleChanges } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { Router } from '@angular/router';

import {
  EmailDetailsFragment, GetEntityById2, GetEntityById2GQL, GetPotentialDuplicates,
  PhoneDetailsFragment
} from 'generated/graphql';

import { isNilOrEmpty } from 'helpers';

/**
 * The SharedContactInfo dialog needs to have this data passed in.
 */
export interface SharedContactInfoDialogData {
  campaignId: string;
  entityId: string;
  email?: EmailDetailsFragment;
  phone?: PhoneDetailsFragment;
  entityMatches: GetPotentialDuplicates.Entities[];
}

@Component({
  selector: 'app-shared-contact-info-dialog',
  templateUrl: './shared-contact-info.dialog.html',
  styleUrls: ['./shared-contact-info.dialog.scss'],
})
export class SharedContactInfoDialog implements OnInit {
  entityMatches: GetPotentialDuplicates.Entities[];
  entity: GetEntityById2.Query['getEntity'];

  showDetails = false;
  detailsExpansionState: { [entityId: string]: boolean } = {};

  get entityTypeNameSingular() {
    return this.entity?.entityType?.nameSingular || 'entity';
  }

  static open(dialog: MatDialog, config: MatDialogConfig<SharedContactInfoDialogData>) {
    return dialog.open(SharedContactInfoDialog, config);
  }

  constructor(
    private _cd: ChangeDetectorRef,
    private _getEntityGQL: GetEntityById2GQL,
    private _router: Router,
    public dialogRef: MatDialogRef<SharedContactInfoDialog>,
    @Inject(MAT_DIALOG_DATA) public data: SharedContactInfoDialogData
  ) {
    if (isNilOrEmpty(data?.entityId) || isNilOrEmpty(data?.campaignId)) {
      throw new Error('An entityId and campaignId must be passed as data to "SharedContactInfoDialog"');
    }
    this.entityMatches = data.entityMatches;
  }

  close(data: any = null) {
    this.dialogRef.close(data);
  }

  ngOnInit(): void {
   this._getEntityGQL.fetch({
        entityId: this.data.entityId,
        campaignId: this.data.campaignId,
        withBestAddress: true,
        withHighligtedTopline: true,
        withEntityType: true,
      }, {
        fetchPolicy: 'cache-first'
      })
      .subscribe(({data}) => {
      this.entity = data.getEntity;
      this._cd.markForCheck();
    });
  }

  onBeginMergeClicked(sourceEntityId: string) {
    this._router.navigate(['/entity/merge'], {
      queryParams: {
        campaignId: this.data.campaignId,
        targetEntityId: this.data.entityId,
        sourceEntityId
      }
    });
    this.close();
  }
}
